export const BACKOFFICE_AUTHORITIES_ROUTE_MAP = {
  bo_view_analytics_dashboard: "fee-types",
  bo_dd_get_charge_types: "fee-types",
  bo_dcir_view_global_participant: "settlement-participants",
  bo_dd_view_participant_users: "participant-users",
  bo_view_participant_report: "participant-reports",
  bo_dd_get_facilitators: "payment-facilitators",
  bo_dd_view_facilitator_users: "payment-facilitator-users",
  bo_dd_get_all_transactions: "transactions",
  bo_dd_get_all_bulk_settlement: "bulk-settlements",
  bo_dd_view_dispute_refunds_on_awaiting_requery: "disputes",
  bo_dd_manage_public_holidays: "public-holidays",
  bo_dd_manage_configurations: "configurations",
};

export const FRONTOFFICE_AUTHORITIES_ROUTE_MAP = {
  fo_view_analytics_dashboard: "transactions",
  fo_dd_get_all_facilitator_users: "payment-facilitator-users",
  fo_dd_get_all_transactions: "transactions",
  fo_dd_get_all_bulk_settlement: "bulk-settlements",
  fo_dd_get_dispute: "disputes/payment-facilitator",
  // fo_dd_get_dispute: "disputes/bank",
};
// note
